import React, {useContext} from "react";
import {observer} from "mobx-react";
import {useTranslation} from "react-i18next";
import "./userMenu.scss";
import MenuItem from "@mui/material/MenuItem";
import {ReactComponent as IconLogout} from "../../../../statics/icons/icon_logout.svg";
import {ReactComponent as IconChangePassword} from "../../../../statics/icons/icon_password.svg";
import {ReactComponent as IconSelectVehicle} from "../../../../statics/icons/icon_car.svg";
import {NavLink} from "react-router-dom";
import {routingAddresses} from "../../../../helpers/routing";
import PopperMenu from "../../shared/popperMenu/popperMenu";
import {storesContext} from "../../../stores/stores";
import {removeCookie} from "../../../../helpers/cookiesUtils";

interface UserMenuProps {
    isOpen: boolean;
    setOpen: (isOpen: boolean) => void;
    anchorRef: React.RefObject<HTMLButtonElement>;
    setDisplaySelectVehiclePopup: (displayPopup: boolean) => void;
}

function UserMenu(props: UserMenuProps): JSX.Element {
    const {t} = useTranslation();
    const userStore = useContext(storesContext).userStore;

    const handleClose = () => {
        props.setOpen(false);
    };

    const removeCookieAction = async () => {
        removeCookie("ownVehicleActionWasPerformed");
    };

    return (
        <PopperMenu
            isOpen={props.isOpen}
            setOpen={props.setOpen}
            anchorEl={props.anchorRef.current}
            testId="user-menu"
            className="user-menu"
            placement="top-end"
        >
            {userStore.displayOwnVehicleSelection && (
                <MenuItem className="menu-item-wrapper">
                    <span
                        className="menu-item"
                        onClick={() => {
                            props.setDisplaySelectVehiclePopup(true);
                            props.setOpen(false);
                        }}
                        data-testid="select-or-change-vehicle"
                    >
                        <IconSelectVehicle className="icon"/>
                        {t("userMenu.selectOwnVehicle")}
                    </span>
                </MenuItem>
            )}
            <MenuItem className="menu-item-wrapper">
                <NavLink
                    to={routingAddresses.user.changePassword}
                    data-testid="change-password"
                    className="menu-item"
                    onClick={handleClose}
                >
                    <IconChangePassword className="icon"/>
                    {t("userMenu.changePassword")}
                </NavLink>
            </MenuItem>
            <MenuItem className="bottom-section menu-item-wrapper">
                <a
                    href={getLogoutUrl()}
                    className="menu-item"
                    onClick={() => {
                        removeCookieAction();
                        handleClose();
                    }}
                    data-testid="logout-user"
                >
                    <IconLogout className="icon"/>
                    {t("userMenu.logout")}
                </a>
            </MenuItem>
        </PopperMenu>
    );

    function getLogoutUrl() {
        const origin = window.location.origin;
        const intermodalUri = encodeURIComponent(origin);

        // keycloakUri must have a domain which is whitelisted in oauth2proxy using --whitelist-domain option
        const keycloakUri = window._env_.AUTH_URL + "/realms/frontend/protocol/openid-connect/logout?client_id=frontend&post_logout_redirect_uri=" + intermodalUri;
        // in turn, this URI must be whitelisted in KeycloakClient resource
        return window._env_.API_URL + "/oauth2/sign_out?rd=" + encodeURIComponent(keycloakUri);
    }
}

export default observer(UserMenu);
